import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";

const CALENDLY = "https://cal.com/rggsales/30min";

const COLS = [
  {
    title: "Service",
    links: [
      { label: "Financial Admin", href: "/#pillars" },
      { label: "Call Operations", href: "/#pillars" },
      { label: "CRM & Lead Ops", href: "/#pillars" },
      { label: "Pricing Support", href: "/#pillars" },
      { label: "HR & People Admin", href: "/#pillars" },
    ],
  },
  {
    title: "Other Services",
    links: [
      { label: "AI Agents & Automations", href: "/services/ai-agents" },
      { label: "Lead Generation", href: "/services/lead-generation" },
      { label: "Executive Assistants", href: "/services/executive-assistants" },
      { label: "RFP & Vendor Registration", href: "/services/rfp-vendor-registration" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "How It Works", href: "/#how-it-works" },
      { label: "Pricing", href: "/pricing" },
      { label: "Projects", href: "/pricing#projects" },
      { label: "Contact", href: "/contact" },
    ],
  },
  {
    title: "Get Started",
    links: [
      { label: "Book a Free Assessment", href: CALENDLY, external: true },
      { label: "Back Office Cost Calculator", href: "/calculator" },
      { label: "Fixed-Fee Projects", href: "/pricing#projects" },
    ],
  },
];

const isInternal = (l) => !l.external && l.href.startsWith("/") && !l.href.startsWith("/#");

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-white border-t border-slate-200">
      <div className="mx-auto max-w-[1200px] px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <Logo />
            <p className="mt-5 text-[15px] leading-relaxed text-slate-500 max-w-sm">
              Your crew handles the job. We handle everything else.
            </p>
            <a
              href={CALENDLY}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-book-call"
              className="mt-6 inline-flex items-center justify-center rounded-lg bg-[#16A06A] hover:bg-[#0E7C53] text-white text-[14px] font-semibold px-5 py-2.5 transition-colors"
            >
              Book a Free Assessment
            </a>
          </div>

          <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-4 gap-8">
            {COLS.map((c) => (
              <div key={c.title}>
                <h4 className="text-[13px] font-semibold uppercase tracking-wider text-[#0A1628]">
                  {c.title}
                </h4>
                <ul className="mt-4 space-y-3">
                  {c.links.map((l) =>
                    l.external ? (
                      <li key={l.label}>
                        <a
                          href={l.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-[14px] text-slate-500 hover:text-[#16A06A] transition-colors"
                        >
                          {l.label}
                        </a>
                      </li>
                    ) : isInternal(l) ? (
                      <li key={l.label}>
                        <Link
                          to={l.href}
                          className="text-[14px] text-slate-500 hover:text-[#16A06A] transition-colors"
                        >
                          {l.label}
                        </Link>
                      </li>
                    ) : (
                      <li key={l.label}>
                        <a
                          href={l.href}
                          className="text-[14px] text-slate-500 hover:text-[#16A06A] transition-colors"
                        >
                          {l.label}
                        </a>
                      </li>
                    )
                  )}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-slate-200 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-[13px] text-slate-400">
            © 2026 RevGen. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-[13px] text-slate-400">
            <a href="#" className="hover:text-[#0A1628]">Privacy</a>
            <a href="#" className="hover:text-[#0A1628]">Terms</a>
            <a href="#" className="hover:text-[#0A1628]">Security</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
